<template>
  <main-layout>

    <div slot="left-side">
      <menubar v-if="pageType == '1'" screenIdParam="M-06-06"></menubar>
      <menubar v-else screenIdParam="M-06-24"></menubar>
    </div>

    <!--  メインページ 開始  -->
    <el-row slot="header">
      <head-title>
        <label slot="title">{{ $t("label.router.ResourceEdit") }}</label>
        <lvory-but
          slot="cancel"
          class="header-clear-btn"
          @click="backPage">
          {{ $t("button.common.cancel") }}
        </lvory-but>
        <narrow-down
          v-if="this.$authCodeCheck('010615') && this.isEdit"
          slot="create"
          class="header-save-btn"
          @click="editGoogleCalendarAuth">
          {{ $t("button.common.data.create") }}
        </narrow-down>
      </head-title>
    </el-row>

    <div slot="body">
      <div style="height: 1px;width: 800px;background-color: #D1D1CD;margin-bottom: 40px;" />
      <div style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 600;font-size: 20px;line-height: 18px;color: #525250;margin-bottom: 40px;">
        Googleカレンダー認証情報編集
      </div>

      <el-form
        ref="ruleForm"
        :rules="rules"
        :model="form"
        class="c-auth-form"
        label-width="188px"
        label-position="left"
        hide-required-asterisk>

        <!-- ドメイン -->
        <el-form-item
          v-if="this.isEdit"
          prop="domain"
          class="m-bottom-5 client-id"
          :label="this.$t('label.system.tenant.googleAuth.domain')">
          <el-input
            class="new-input-shadow"
            maxlength="256"
            v-model="form.domain">
          </el-input>
        </el-form-item>

        <el-form-item
          v-else
          prop="domain"
          class="m-bottom-5 client-id"
          :label="this.$t('label.system.tenant.googleAuth.domain')">
          <div class="domain">
            <span>{{ form.domain }}</span>
          </div>
        </el-form-item>

        <!-- クライアントID -->
        <el-form-item
          v-if="this.isEdit"
          prop="clientID"
          class="m-bottom-5 client-id"
          :label="'クライアントID'">
          <el-input
            class="new-input-shadow"
            maxlength="256"
            v-model="form.clientID">
          </el-input>
        </el-form-item>

        <!-- シークレットキー -->
        <el-form-item
          v-if="this.isEdit"
          prop="secretKey"
          class="last-input-sp"
          :label="'シークレットキー'">
          <el-input
            class="new-input-shadow"
            :rows="5"
            type="textarea"
            v-model="form.secretKey"
            maxlength="3000">
          </el-input>
          <img @click="form.secretKey = null" class="iot-popover-image-size" src="@/assets/icon/close-btn.svg" alt="">
        </el-form-item>

        <!-- 管理者Email -->
        <el-form-item
          v-if="this.isEdit"
          prop="manageEmail"
          class="m-bottom-5 client-id"
          :label="this.$t('label.system.tenant.googleAuth.manageEmail')">
          <el-input
            class="new-input-shadow"
            maxlength="256"
            v-model="form.manageEmail">
          </el-input>
        </el-form-item>

      </el-form>

      <div style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 600;font-size: 20px;line-height: 18px;color: #525250;margin-bottom: 40px;">
        {{ $t("label.system.tenant.detail.OutlookAuthEdit") }}
      </div>
      <el-form
        ref="ruleForm"
        :rules="rules"
        :model="form"
        class="c-outlook-form"
        label-width="188px"
        label-position="left"
        hide-required-asterisk>

        <!-- ドメイン -->
        <el-form-item
          v-if="this.isEdit"
          prop="domain"
          class="m-bottom-5 client-id"
          :label="this.$t('label.system.tenant.outlookAuth.domain')">
          <el-input
            class="new-input-shadow"
            maxlength="256"
            v-model="form.outlookDomain">
          </el-input>
        </el-form-item>

        <!-- テナントID -->
        <el-form-item
          v-if="this.isEdit"
          prop="orgID"
          class="m-bottom-5 client-id"
          :label="this.$t('label.system.tenant.outlookAuth.tenantId')">
          <el-input
            class="new-input-shadow"
            maxlength="256"
            v-model="form.orgID">
          </el-input>
        </el-form-item>

        <el-form-item
          v-else
          prop="orgID"
          class="m-bottom-5 client-id"
          :label="this.$t('label.system.tenant.outlookAuth.tenantId')">
          <div class="orgID">
            <span>{{ form.orgID }}</span>
          </div>
        </el-form-item>

        <!-- アプリケーションID -->
        <el-form-item
          v-if="this.isEdit"
          prop="applicationID"
          class="m-bottom-5 client-id"
          :label="this.$t('label.system.tenant.outlookAuth.applicationID')">
          <el-input
            class="new-input-shadow"
            maxlength="256"
            v-model="form.applicationID">
          </el-input>
        </el-form-item>

        <!-- アプリケーションパスワード -->
        <el-form-item
          v-if="this.isEdit"
          prop="applicationPassword"
          class="m-bottom-5 client-id"
          :label="this.$t('label.system.tenant.outlookAuth.applicationPassword')">
          <el-input
            class="new-input-shadow"
            maxlength="256"
            v-model="form.applicationPassword">
          </el-input>
        </el-form-item>

      </el-form>

      <div
        class="c-auth-save-btn"
      >
        <narrow-down
          v-if="this.$authCodeCheck('010615') && this.isEdit"
          style="margin-left3: 170px;"
          @click="editGoogleCalendarAuth">
          {{ $t("button.common.data.save") }}
        </narrow-down>
      </div>

      <loading-dialog :dialogVisible="showLoading" />

    </div>

  </main-layout>
</template>

<script>
import Menubar from "@/components/leftmenu/DashBoard"
import LvoryBut from "@/components/common/generalButton/LvoryBut"
import HeadTitle from "@/components/common/head/head"
import MainLayout from "@/layout/NewDesignLayout"
import NarrowDown from "@/components/common/generalButton/NarrowDown"
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import errorCodeMsg from "@/utils/error-code-msg"
import SystemManageApi from "@/api/SystemManageApi"
import GoogleCalendarAuthRuleFactory from "@/rules/rule-tenant-calendar-edit.js"

export default {
  name: "TenantCalendarAuth",
  components: {
    Menubar: Menubar,
    LvoryBut: LvoryBut,
    HeadTitle: HeadTitle,
    MainLayout: MainLayout,
    NarrowDown: NarrowDown,
    LoadingDialog: LoadingDialog
  },
  data() {
    return {
      isClearBtn: false,
      saveIsShow: false,
      saveMsgParam: this.$t("message.common.validation.updateMessage", {
        field: this.$t('label.system.tenant.googleAuth.googleAuth')
      }),
      deleteIsShow: false,
      deleteMsgParam: this.$t("message.common.validation.confDelete", {
        field: this.$t('label.system.tenant.googleAuth.googleAuth')
      }),
      showLoading: false,
      isEdit: false,
      rules: GoogleCalendarAuthRuleFactory.googleCalendarAuthRules(this),
      orgId: null,
      pageType: null,
      form: {
        domain: null,
        clientID: null,
        secretKey: null,
        manageEmail: null,
        outlookDomain: null,
        orgID: null,
        applicationID: null,
        applicationPassword: null
      },
      ownerDetail: null,
    }
  },
  created() {
    this.pageType = this.$route.query.pageType
    this.$authCheck("010614")

    if (this.pageType == '1') {

      if (this.$IsSBManager() || this.$IsOwnerManager()) {
        this.isEdit = true
      }

      let breadcrumb = [
        {
          path: "/",
          title: "label.router.home",
        },
        {
          path: "/system/setting/various",
          title: "label.router.set",
        },
        {
          path: "",
          title: "label.router.comprehensive",
        },
        {
          path: "/system/owners/search",
          title: "label.router.owner",
        },
        {
          path: "",
          title: "label.router.ResourceEdit",
        },
      ]
      this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
    } else {

      if (this.$IsSBManager() ||this.$IsTenantManager()) {
        this.isEdit = true
      }

      var breadcrumb = [
        {
          path: "/",
          title: "label.router.home",
        },
        {
          path: "/system/setting/various",
          title: "label.router.set",
        },
        {
          path: "",
          title: "label.router.comprehensive",
        },
        {
          path: "/system/tenants/search",
          title: "label.router.Thetenant",
        },
        {
          path: "",
          title: "label.router.tenantDetail",
        },
        {
          path: "",
          title: "label.router.ResourceEdit",
        },
      ]
      this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
    }
  },
  mounted() {
    this.orgId = this.$route.query.orgId
    if(this.$route.query.ownerDetail !== undefined && this.$route.query.ownerDetail !== null){
      this.ownerDetail = JSON.parse(this.$route.query.ownerDetail)
    }

    this.getGoogleCalendarAuth()

  },
  methods: {

    getGoogleCalendarAuth() {
      this.showLoading = true
      SystemManageApi.getResource(this.orgId)
      .then(({data}) => {
        if (data.body != null && data.body != undefined && data.body != "") {
          if (data.body.googleResourceAuthInfo != null && data.body.googleResourceAuthInfo != undefined && data.body.googleResourceAuthInfo != "") {
            this.form.domain = data.body.googleResourceAuthInfo.domain
            this.form.clientID = data.body.googleResourceAuthInfo.clientID
            this.form.secretKey = data.body.googleResourceAuthInfo.secretKey
            this.form.manageEmail = data.body.googleResourceAuthInfo.manageEmail
          }

          if (data.body.outlookResourceAuthInfo != null && data.body.outlookResourceAuthInfo != undefined && data.body.outlookResourceAuthInfo != "") {
            this.form.outlookDomain = data.body.outlookResourceAuthInfo.outlookDomain
            this.form.orgID = data.body.outlookResourceAuthInfo.tenantID
            this.form.applicationID = data.body.outlookResourceAuthInfo.applicationID
            this.form.applicationPassword = data.body.outlookResourceAuthInfo.applicationSecret
          }
        }
      })
      .catch((error) => {
        this.isClearBtn = false
        errorCodeMsg(error, this)
      })
      .finally(() => {
        this.showLoading = false
      })
    },

    editGoogleCalendarAuth() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {

          let inputGoogleErrorFlg = false
          let inputOutlookErrorFlg = false
          let specialCheckFlag = false

          if (this.$IsNullOrEmpty(this.form.domain) && (!this.$IsNullOrEmpty(this.form.clientID) || !this.$IsNullOrEmpty(this.form.secretKey) || !this.$IsNullOrEmpty(this.form.manageEmail))) {
            inputGoogleErrorFlg = true
          } else if (this.$IsNullOrEmpty(this.form.clientID) && (!this.$IsNullOrEmpty(this.form.domain) || !this.$IsNullOrEmpty(this.form.secretKey) || !this.$IsNullOrEmpty(this.form.manageEmail))) {
            inputGoogleErrorFlg = true
          } else if (this.$IsNullOrEmpty(this.form.secretKey) && (!this.$IsNullOrEmpty(this.form.domain) || !this.$IsNullOrEmpty(this.form.clientID) || !this.$IsNullOrEmpty(this.form.manageEmail))) {
            inputGoogleErrorFlg = true
          } else if (this.$IsNullOrEmpty(this.form.manageEmail) && (!this.$IsNullOrEmpty(this.form.domain) || !this.$IsNullOrEmpty(this.form.clientID) || !this.$IsNullOrEmpty(this.form.secretKey))) {
            inputGoogleErrorFlg = true
          }

          if (this.$IsNullOrEmpty(this.form.orgID) && (!this.$IsNullOrEmpty(this.form.applicationID) || !this.$IsNullOrEmpty(this.form.applicationPassword) || !this.$IsNullOrEmpty(this.form.outlookDomain))) {
            inputOutlookErrorFlg = true
          } else if (this.$IsNullOrEmpty(this.form.applicationID) && (!this.$IsNullOrEmpty(this.form.orgID) || !this.$IsNullOrEmpty(this.form.applicationPassword) || !this.$IsNullOrEmpty(this.form.outlookDomain))) {
            inputOutlookErrorFlg = true
          } else if ((!this.$IsNullOrEmpty(this.form.orgID) || !this.$IsNullOrEmpty(this.form.applicationID) || !this.$IsNullOrEmpty(this.form.outlookDomain)) && this.$IsNullOrEmpty(this.form.applicationPassword)) {
            inputOutlookErrorFlg = true
          } else if (this.$IsNullOrEmpty(this.form.outlookDomain) && (!this.$IsNullOrEmpty(this.form.applicationID) || !this.$IsNullOrEmpty(this.form.applicationPassword) || !this.$IsNullOrEmpty(this.form.orgID))) {
            inputOutlookErrorFlg = true
          }

          if (!this.$IsNullOrEmpty(this.form.secretKey)) {
            if (this.$checkSpecialKeyWord(this.form.secretKey)) {
              specialCheckFlag = true
            }
          }

          if (inputGoogleErrorFlg) {
            this.$messageIotError('Googleの認証に失敗しました。Googleカレンダー認証情報の入力内容をご確認ください')
          } else if (inputOutlookErrorFlg) {
            this.$messageIotError('Outlookの認証に失敗しました。Outlook認証情報の入力内容をご確認ください')
          } else if (specialCheckFlag) {
            this.$messageIotError(this.$t('message.common.validation.inputSpecialKeyword',{
                field: "シークレットキー",
                keyWord: "<、>、\"、'"
            }))
          } else {
            this.doneEditGoogleCalendarAuth()
          }
        }
      })
    },

    doneEditGoogleCalendarAuth() {

      let request = {
        domain: this.form.domain,
        clientID: this.form.clientID,
        secretKey: this.form.secretKey,
        manageEmail: this.form.manageEmail,
        outlookDomain: this.form.outlookDomain,
        tenantID: this.form.orgID,
        applicationID: this.form.applicationID,
        applicationSecret: this.form.applicationPassword,
      }

      this.showLoading = true
      SystemManageApi.updateResource(this.orgId, request)
        .then(({data}) => {
          if (data.statusCode == "Success") {
            this.$messageIotSuccess(this.$t("message.common.save"))
            this.getGoogleCalendarAuth()
          } else if (data.statusCode == "Failure.Failure_AuthParameterIncorrect" || data.statusCode == "Failure.Failure_GoogleAuthFailed" || data.statusCode == "Failure.Failure_OutlookAuthParameterIncorrect") {
            this.$messageIotError(this.$t('message.common.error.ERR_GOOGLE_CALENDAR_AUTH'))
          }
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .finally(() => {
          this.showLoading = false
        })
    },

    backPage () {
      if (this.pageType == '1') {
        this.$router.push({
          name: "system-owner-setting-edit",
          query: {
            orgId: this.orgId,
            ownerDetail: JSON.stringify(this.ownerDetail)
          }
        })
      } else {
        this.$router.push({
          name: "system-tenant-detail",
          params: {
            tenantId: this.orgId
          }
        })
      }
    }

  }
}
</script>

<style scoped lang="scss">
.header-save-btn::v-deep {
  .my-button {
    width: 152px;
    height: 32px;
  }
}
.header-clear-btn::v-deep {
  .my-button {
    width: 152px;
    height: 32px;
  }
}
.c-auth-form::v-deep {
  .el-form-item {
    margin-bottom: 0px;
  }
  .el-input__inner {
    height: 44px !important;
  }
  .el-form-item__label {
    font-size: 16px;
  }
}
.c-outlook-form::v-deep {
  .el-form-item {
    margin-bottom: 0px;
  }
  .el-input__inner {
    height: 44px !important;
  }
  .el-form-item__label {
    font-size: 13px;
  }
}
.c-auth-save-btn {
  margin-left: 188px;
  margin-top: 60px;
}
.domain {
  color: #525250;
  font-size: 14px;
}
.orgID {
  color: #525250;
  font-size: 14px;
}
.client-id::v-deep {
  .el-input .el-input__inner {
    width: 528px;
  }
}
::v-deep .new-input-shadow .el-input__inner {
  background: #F7F7F2 !important;
  box-shadow: inset 3px 3px 3px #DEDED1, inset -3px -3px 4px #FFFFFA !important;
  border-radius: 8px;
}
::v-deep .new-input-shadow .el-textarea__inner {
  background: #F7F7F2 !important;
  box-shadow: inset 3px 3px 3px #DEDED1, inset -3px -3px 4px #FFFFFA !important;
  border-radius: 8px;
}
.iot-popover-image-size {
  position: relative;
  cursor: pointer;
  top: -170px;
  left: 500px;
  height: 18px;
}
::v-deep .last-input-sp .el-form-item__content .el-form-item__error {
  margin-top: -40px;
}
</style>
